import type { VoidFunctionComponent } from 'react';

import FilterCardCheckboxes from '../../generic/Filter/FilterCardCheckboxes';
import type { AnyFilter, Depth } from '../../../../shared/organizationPackages/filters';
import type { SelectOption } from '../../../types';

const DEPTH_OPTIONS: SelectOption[] = [
  { value: 'direct', label: 'Direct' },
  { value: 'transitive', label: 'Transitive' },
];

type Props = {
  depths: Depth[];
  setFilters: (filter: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersPackageDepth displays two checkboxes which can be used to
 */
const PackageInventoryFiltersPackageDepth: VoidFunctionComponent<Props> = ({ depths, setFilters }) => {
  // map current depths to SelectOption format
  const selectedCheckboxes = depths.map((depth: string) => ({
    label: DEPTH_OPTIONS.find(option => option.value === depth)?.label || depth,
    value: depth,
  }));

  // handle onChange from FilterCardCheckboxes
  const onChange = (newSelected: SelectOption[]) => {
    const selectedDepths = newSelected.map(({ value }) => value as Depth);
    setFilters({ depth: selectedDepths });
  };

  return (
    <FilterCardCheckboxes
      label="Dependency depth"
      options={DEPTH_OPTIONS}
      values={selectedCheckboxes}
      onChange={onChange}
      testId="package-inventory-filters--depth"
    />
  );
};

export default PackageInventoryFiltersPackageDepth;
